import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import './admin.css';

const adminNav = [
  { to: '/admin/dashboard', icon: '📊', label: 'Dashboard' },
  { to: '/admin/tickets',   icon: '🎫', label: 'Tickets' },
  { to: '/admin/scan',      icon: '📷', label: 'Scan QR' },
  { to: '/admin/coupons',   icon: '🏷️', label: 'Coupons' },
  { to: '/admin/gallery',   icon: '🖼️', label: 'Gallery' },
  { to: '/admin/users',     icon: '👥', label: 'Users' },
  { to: '/admin/settings',  icon: '⚙️', label: 'Settings' }
];

const staffNav = [
  { to: '/admin/scan',    icon: '📷', label: 'Scan QR' },
  { to: '/admin/tickets', icon: '🎫', label: 'Tickets' }
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const role    = localStorage.getItem('als_admin_role') || 'staff';
  const userRaw = localStorage.getItem('als_admin_user');
  const user    = userRaw ? JSON.parse(userRaw) : { displayName: '', username: '', role };
  const navItems = role === 'admin' ? adminNav : staffNav;

  const currentLabel = navItems.find(n => location.pathname.startsWith(n.to))?.label || 'Admin';

  const logout = () => {
    localStorage.removeItem('als_admin_token');
    localStorage.removeItem('als_admin_role');
    localStorage.removeItem('als_admin_user');
    navigate('/admin/login');
  };

  const SidebarContent = () => (
    <>
      <div className="admin-sidebar-logo">ALS Admin</div>

      <div className="admin-user-badge">
        <div className="admin-user-avatar">
          {(user.displayName || user.username || '?')[0].toUpperCase()}
        </div>
        <div>
          <div className="admin-user-name">{user.displayName || user.username}</div>
          <div className={`admin-user-role ${role}`}>
            {role === 'admin' ? '⭐ Admin' : '👤 Staff'}
          </div>
        </div>
      </div>

      <nav className="admin-nav">
        {navItems.map(item => (
          <NavLink
            key={item.to} to={item.to}
            className={({ isActive }) => `admin-nav-item${isActive ? ' active' : ''}`}
            onClick={() => setOpen(false)}
          >
            <span className="admin-nav-icon">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div style={{ marginTop: 'auto' }}>
        {role === 'admin' && (
          <a href="/" target="_blank" rel="noreferrer"
            className="admin-nav-item"
            style={{ marginBottom: 4, display: 'flex' }}
            onClick={() => setOpen(false)}
          >
            <span className="admin-nav-icon">🏠</span> View Site
          </a>
        )}
        <button className="admin-sidebar-logout" onClick={logout}>
          <span>🚪</span> Sign Out
        </button>
      </div>
    </>
  );

  return (
    <div className="admin-app">

      {/* ─── Desktop sidebar ─── */}
      <aside className="admin-sidebar">
        <SidebarContent />
      </aside>

      {/* ─── Mobile top bar ─── */}
      <div className="admin-topbar">
        <button className="admin-topbar-hamburger" onClick={() => setOpen(true)}>
          <span /><span /><span />
        </button>
        <div className="admin-topbar-title">{currentLabel}</div>
        <div className="admin-topbar-avatar" onClick={() => setOpen(true)}>
          {(user.displayName || user.username || '?')[0].toUpperCase()}
        </div>
      </div>

      {/* ─── Mobile slide-out overlay ─── */}
      {open && (
        <div className="admin-mobile-overlay" onClick={() => setOpen(false)}>
          <aside
            className="admin-mobile-sidebar"
            onClick={e => e.stopPropagation()}
          >
            <button className="admin-mobile-close" onClick={() => setOpen(false)}>✕</button>
            <SidebarContent />
          </aside>
        </div>
      )}

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
